import { Environment } from './environment.interface';

export function DevConfig(host: string, production = true): Environment {
    return {
        production,
        host,
        stage: 'dev',
        appId: '2dcdfd03-dd43-4836-9e8f-03d668f460b5',
        principalDisplayName: 'Octiga Cloud Security - Dev',
        whitelabelBasePath: '/branding',
        docsBaseUrl: 'https://docs.devoctiga.com',
        stripePublishableKey:
            'pk_test_51TiyH2EbZeQfWQ2TwRpxRlY9aCF8mNR8X19Q3dEm1dmCHiOg24B7K6gpoclYbaVtpTJY29y0OVNjrmbPRLLBAdXg005HvRoiUJ',
        oauth: {
            client: {
                client_id: '2dcdfd03-dd43-4836-9e8f-03d668f460b5',
                authenticate_redirect_uri: `${host}/api/microsoft/oauth/authenticate`,
                authorise_redirect_uri: `${host}/api/microsoft/oauth/authorise`,
                return_url: `${host}/dashboard`,
            },
            msp: {
                client_id: '1265e19a-a324-4a6e-b96f-00e673ce2b44',
                authenticate_redirect_uri: `${host}/api/microsoft/oauth/authenticate/msp`,
                return_url: `${host}/msp/dashboard`,
            },
        },
        // posthog: {
        //     enabled: false,
        //     key: '',
        //     host: '',
        // },
    };
}

export const environment = DevConfig('https://devoctiga.com');
